module.exports = "/images/delete-objective-input-icon.png?5ed1c66e3fb46e5dd9aaa85f6da9dedf";